import { render } from "./SummaryInfo.vue?vue&type=template&id=18617a14&scoped=true&ts=true"
import script from "./SummaryInfo.vue?vue&type=script&lang=ts"
export * from "./SummaryInfo.vue?vue&type=script&lang=ts"

import "./SummaryInfo.vue?vue&type=style&index=0&id=18617a14&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18617a14"]])

export default __exports__